import { jsx as _jsx } from "react/jsx-runtime";
import RfSignal from 'console/images/rf-indicators/rf-signal.svg';
import RfSignal433 from 'console/images/rf-indicators/rf-signal.sensor-433.svg';
import RfSignal1 from 'console/images/rf-indicators/rf-signal.level-1.svg';
import RfSignal2 from 'console/images/rf-indicators/rf-signal.level-2.svg';
import RfSignal3 from 'console/images/rf-indicators/rf-signal.level-3.svg';
import RfBattery from 'console/images/rf-indicators/rf-battery.svg';
import RfBattery0 from 'console/images/rf-indicators/rf-battery.level-0.svg';
import RfBattery1 from 'console/images/rf-indicators/rf-battery.level-1.svg';
import RfBattery2 from 'console/images/rf-indicators/rf-battery.level-2.svg';
import RfBattery3 from 'console/images/rf-indicators/rf-battery.level-3.svg';
import { ResponsiveIcon } from '../../../icon/responsive';
export function getRfBatteryIcon(level) {
    switch (level) {
        case 0:
            return (_jsx(ResponsiveIcon, { color: "inherit", viewBox: "0 0 16 16", Icon: RfBattery0 }));
        case 1:
            return (_jsx(ResponsiveIcon, { color: "inherit", viewBox: "0 0 16 16", Icon: RfBattery1 }));
        case 2:
            return (_jsx(ResponsiveIcon, { color: "inherit", viewBox: "0 0 16 16", Icon: RfBattery2 }));
        case 3:
            return (_jsx(ResponsiveIcon, { color: "inherit", viewBox: "0 0 16 16", Icon: RfBattery3 }));
        default:
            return (_jsx(ResponsiveIcon, { color: "inherit", viewBox: "0 0 16 16", Icon: RfBattery }));
    }
}
export function getRfIcon(level, is433) {
    if (is433) {
        return (_jsx(ResponsiveIcon, { color: "inherit", fontSize: "0.9em", viewBox: "0 0 16 16", Icon: RfSignal433 }));
    }
    switch (level) {
        case 1:
            return (_jsx(ResponsiveIcon, { color: "inherit", viewBox: "0 0 16 16", Icon: RfSignal1 }));
        case 2:
            return (_jsx(ResponsiveIcon, { color: "inherit", viewBox: "0 0 16 16", Icon: RfSignal2 }));
        case 3:
            return (_jsx(ResponsiveIcon, { color: "inherit", viewBox: "0 0 16 16", Icon: RfSignal3 }));
        default:
            return (_jsx(ResponsiveIcon, { color: "inherit", viewBox: "0 0 16 16", Icon: RfSignal }));
    }
}
